var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuditTrail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33301 1.33398C3.12387 1.33398 1.33301 3.12484 1.33301 5.33398V10.6673C1.33301 12.8765 3.12387 14.6673 5.333 14.6673H10.6663C12.8755 14.6673 14.6663 12.8765 14.6663 10.6673V5.33398C14.6663 3.12485 12.8755 1.33398 10.6663 1.33398H5.33301ZM7.3517 5.02938C7.23383 4.76417 6.97352 4.59077 6.68337 4.58418C6.39322 4.57759 6.12531 4.73899 5.99552 4.99857L4.86948 7.25065H3.99967C3.58546 7.25065 3.24967 7.58644 3.24967 8.00065C3.24967 8.41486 3.58546 8.75065 3.99967 8.75065H5.33301C5.61709 8.75065 5.87678 8.59015 6.00383 8.33606L6.62643 7.09085L8.64765 11.6386C8.77011 11.9141 9.04568 12.0895 9.34715 12.0839C9.64863 12.0782 9.91738 11.8925 10.0294 11.6125L11.1741 8.75065H11.9997C12.4139 8.75065 12.7497 8.41486 12.7497 8.00065C12.7497 7.58644 12.4139 7.25065 11.9997 7.25065H10.6663C10.3597 7.25065 10.0839 7.43736 9.96998 7.72211L9.29663 9.40548L7.3517 5.02938Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditTrail);
export default __webpack_public_path__ + "static/media/audit-trail.387dd704.svg";
export { ForwardRef as ReactComponent };